import * as _ from 'lodash'
import * as Model from '../types/document'
import { Cursor, CursorV } from 'src/lib/Cursor';
import { docC, network, documentC } from 'src/globals';
import { Path } from 'src/lib/Path';
import { deleteStepFromSteps } from 'src/actions';

export interface BlockInfo {
  path: Path,
  parentBlockId: Model.BlockId | undefined,
}

export const BlockInfo = {
  blockC(info: BlockInfo): Cursor<Model.Block> {
    return docC<Model.Block>(info.path)
  }
}

type BlockInfoTable = {[blockId: string]: BlockInfo}


export const blockInfo = network.valueFunc('blockInfo', (blockId: Model.BlockId): BlockInfo => {
  return blockInfoTable()[blockId]
}, _.isEqual)

export const blockInfoTable = network.valueFunc('blockInfoTable', () => {
  let table = {} as BlockInfoTable

  const document = documentC.get()
  documentC._('definitions').fetch().call(CursorV.elemsKeyed, 'id').forEach((definitionC) =>
    doBlock(table, definitionC, undefined)
  )
  if (documentC._('scratch').get()) {
    doBlock(table, documentC._('scratch').fetch(), undefined)
  }

  return table
})

function doBlock(table: BlockInfoTable, blockC: CursorV<Model.Block>, parentBlockId: Model.BlockId | undefined) {
  const blockId = blockC.value().id
  table[blockId] = {
    path: blockC.path(),
    parentBlockId: parentBlockId
  }

  doSteps(table, blockC._('steps'), blockId)
}

function doSteps(table: BlockInfoTable, stepsC: CursorV<Model.Steps | undefined>, parentBlockId: Model.BlockId | undefined) {
  const maybeStepsC = stepsC.call(CursorV.unwrapMaybe)
  if (!maybeStepsC) { return }
  maybeStepsC.call(CursorV.elemsKeyed, 'id').forEach((stepC) =>
    doStep(table, stepC, parentBlockId)
  )
}

function doStep(table: BlockInfoTable, stepC: CursorV<Model.Step>, parentBlockId: Model.BlockId | undefined) {
  const step = stepC.value()

  switch (step.stepType) {
  case 'graph': {
    const graphC = stepC as CursorV<Model.Graph>
    graphC.select('calls').call(CursorV.values).forEach((callC) => {
      if (callC.value().callType === 'list-op') {
        const listOpC = callC as CursorV<Model.ListOpCall>
        doBlock(table, listOpC._('block'), parentBlockId)
      }  
    })
    break }
  case 'switch': {
    const switchC = stepC as CursorV<Model.Switch>
    switchC.select('cases').call(CursorV.elems).forEach((caseC) => {
      doSteps(table, caseC._('condition'), parentBlockId)
      doSteps(table, caseC._('steps'), parentBlockId)
    })
    break }
  case 'text':
    break
  }
}



// WEBPACK FOOTER //
// ./src/model/blocks.ts